import SubscriptionForm from '@components/subscription/SubscriptionForm'

function Prelaunch() {
  return (
    <div className="section-block h-100v bg-gray-900 grid grid-cols-12 justify-around ">
      <div className="section-inner section-fit section-relative self-center col-span-12 lg:col-span-6 lg:col-start-4 mx-12 lg:mx-0">
        <div>
          <img
            className="w-full"
            alt="Lifeforce"
            src="//v.fastcdn.co/u/29cc0bed/59855610-0-LF-logo-White.png"
          />
        </div>

        <div className="flex flex-col">
          <h3 className="font-bold text-3xl text-white mt-8 self-center text-center">
            Performance programs personalized to your body and your life.&nbsp;
          </h3>
          <span className="text-3xl text-white font-bold self-center mt-2">
            What’s your Lifeforce?
          </span>
        </div>

        <div className="mt-10"></div>

        <div className="grid grid-cols-3">
          <p className="text-white col-span-3 md:col-span-1 md:col-start-2">
            Signup now to be the first in line
          </p>
          <br />
          <SubscriptionForm className="col-span-3 md:col-span-1 md:col-start-2" />
        </div>
      </div>
    </div>
  )
}

export default Prelaunch
